import { CandidateType } from './types';
/** enum type to simplify setting "user-friendly" notation if necessary */
export var NOTATION;
(function (NOTATION) {
    NOTATION["FASTA"] = "fasta";
    NOTATION["SEPARATOR"] = "separator";
    NOTATION["HELM"] = "helm";
    /* Requires notation handler */ NOTATION["CUSTOM"] = "custom";
    /* Requires notation handler */ NOTATION["BILN"] = "biln";
})(NOTATION || (NOTATION = {}));
export var ALPHABET;
(function (ALPHABET) {
    ALPHABET["DNA"] = "DNA";
    ALPHABET["RNA"] = "RNA";
    ALPHABET["PT"] = "PT";
    /** Unknown */
    ALPHABET["UN"] = "UN";
})(ALPHABET || (ALPHABET = {}));
export var TAGS;
(function (TAGS) {
    TAGS["aligned"] = "aligned";
    TAGS["alphabet"] = "alphabet";
    TAGS["alphabetSize"] = ".alphabetSize";
    TAGS["alphabetIsMultichar"] = ".alphabetIsMultichar";
    TAGS["separator"] = "separator";
    TAGS["isHelmCompatible"] = ".isHelmCompatible";
    TAGS["positionNames"] = ".positionNames";
    TAGS["positionLabels"] = ".positionLabels";
    TAGS["regions"] = ".regions";
    TAGS["positionShift"] = ".positionShift";
    TAGS["selectedPosition"] = ".selectedPosition";
    TAGS["polymerTypeColumnName"] = ".polymerTypeColumnName";
    TAGS["annotations"] = ".annotations";
    TAGS["numberingScheme"] = ".numberingScheme";
    TAGS["annotationColumnName"] = ".annotationColumnName";
})(TAGS || (TAGS = {}));
export { TAGS as BioTags };
export const positionSeparator = ', ';
export const monomerRe = /(?:\[([A-Za-z0-9_\-,()]+)\])|([A-Za-z\-])/g;
export const helmRe = /(PEPTIDE1|DNA1|RNA1)\{([^}]+)}/g;
export const helmPp1Re = /\[([^\[\]]+)]/g;
export const Alphabets = new class {
    constructor() {
        this.fasta = {
            peptide: new Set([
                'G', 'L', 'Y', 'S', 'E', 'Q', 'D', 'N', 'F', 'A',
                'K', 'R', 'H', 'C', 'V', 'P', 'W', 'I', 'M', 'T',
            ]),
            dna: new Set(['A', 'C', 'G', 'T']),
            rna: new Set(['A', 'C', 'G', 'U']),
        };
    }
}();
export const candidateAlphabets = [
    new CandidateType(ALPHABET.PT, Alphabets.fasta.peptide, 0.50),
    new CandidateType(ALPHABET.DNA, Alphabets.fasta.dna, 0.55),
    new CandidateType(ALPHABET.RNA, Alphabets.fasta.rna, 0.55),
];
/** Canonical gap symbol */
export const GAP_SYMBOL = '';
export const GapOriginals = {
    [NOTATION.FASTA]: '-',
    [NOTATION.SEPARATOR]: '',
    [NOTATION.HELM]: '*',
    [NOTATION.BILN]: '',
};
export const MONOMER_MOTIF_SPLITTER = ' , ';
/** Tag on Monomer columns storing the nqName of a function that returns an IMonomerCanonicalizer.
 *  The `.%` prefix ensures this tag is persisted with projects. */
export const MONOMER_CANONICALIZER_FUNC_TAG = '.%monomer-canonicalizer-func';
/** Column temp key for the cached IMonomerCanonicalizer instance */
export const MONOMER_CANONICALIZER_TEMP = 'monomer-canonicalizer';
export const NOTATION_PROVIDER_CONSTRUCTOR_ROLE = 'notationProviderConstructor';
//# sourceMappingURL=consts.js.map